import './WhatsApp.css'


const WhatsApp = () =>{
    return(
        <div>
            <a class='btn-wsp' href="https://linktr.ee/tuclubindumentaria" target="_blank" rel="noreferrer">
                <i class='bi bi-whatsapp icon-wsp'></i>
            </a>
        </div>
    )
}

export default WhatsApp